<form (ngSubmit)="unPublishMass()" [formGroup]="formGroup" class="dialog-container selection">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="title-header">
    <h4>Revert published reports</h4>
    <button (click)="close()" class="icon-button icon-close" type="button"></button>
  </div>
  <div class="container">
    <div class="section-container table-section">
      <div #itemContainer class="table-container">
        <div class="item-container">
          @if (pagedData?.items && pagedData?.totalItems !== 0) {
            @for (item of paginatedData; track item.id) {
              <app-organisation-item (click)="changeSelected(item)" [active]="item.selected" [item]="item" />
            }
          }
        </div>
        @if (!pagedData) {
          <app-loading-indicator />
        }
      </div>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      @if (pagedData?.totalItems > 1) {
        <div class="left-container flex-1">
          <sag-ui-checkbox formControlName="allSelected" (change)="selectAll()"> Select all </sag-ui-checkbox>
        </div>
      }
      <div class="right-container flex-1">
        <sag-ui-button color="primary" type="submit" [disabled]="isSaving">
          {{ "default.buttons.confirm" | translate }}
        </sag-ui-button>
      </div>
    </div>
  </div>
</form>
